module.exports = __webpack_public_path__ + "img/invitation.860b970e.png";